import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface SectionHeaderProps {
  title: string;
  /** Right-aligned action: scope toggles, a "→" link, a count. */
  action?: ReactNode;
  className?: string;
}

/** Section h2 with a hairline under it, heading left, action right. */
export function SectionHeader({ title, action, className }: SectionHeaderProps) {
  return (
    <div className={cn('flex items-baseline justify-between gap-4 border-b border-line pb-3', className)}>
      <h2 className="text-[19px] font-semibold tracking-[-0.02em]">{title}</h2>
      {action && <div className="flex items-center gap-[14px]">{action}</div>}
    </div>
  );
}
